export const validateIterate = ({ step, status }) => {
  if (!step?.arguments?.stepId) {
    return { status, id: 'go-to-action', message: 'Add step to loop' };
  }

  return { status: 'valid' };
};
